// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('productionRoutingAdd', {
//         templateUrl: 'views/components/views/productionRoutingAdd/productionRoutingAdd.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'utilityService', 'productionRoutingAddService', 'ttGridFactory', function ($stateParams, utilityService, productionRoutingAddService, ttGridFactory) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let prodId = $stateParams.prod_id;

//             vm.model = {
//                 setting: {},
//                 selectListProductionRoutings: [],
//                 gridReady: false
//             };

//             vm.grid = new ttGridFactory({
//                 rememberId: 'w_productionroutingadd_grid',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             });
            
//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadSetting() {
//                 vm.model.setting = (await productionRoutingAddService.getSetting({ prod_id: prodId }))[0];
//             }

//             async function loadProductionRoutings() {
//                 vm.model.selectListProductionRoutings = await productionRoutingAddService.listProductionRoutings();
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region GRID PROCEDURE FUNCTION CALLS

//             async function loadGrid() {
//                 vm.grid.dataTask.loadData = {
//                     method: 3657,
//                     parameters: vm.model.setting
//                 };

//                 vm.model.gridReady = true;

//                 if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//             }

//             // #endregion GRID PROCEDURE FUNCTION CALLS

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'productionrouting_keyno':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.productionrouting_keyno) !== true) return;

//                         vm.model.setting.productionrouting_keyno = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.productionrouting_keyno, true) !== true) return;

//                         loadGrid();
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 await loadSetting();
//                 loadProductionRoutings();
//                 loadGrid();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
